module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 444
// module chunks = 0